import { useTranslation } from "react-i18next";
import { FilterableMultiSelect } from "@carbon/react";
import { OrderState } from "../../types";
import "./orders.scss";

export interface OrderStateOption {
  value: OrderState;
  label: string;
}

export interface OrderStateFilterProps {
  /** Distinguishes element ids between `/orders` and `/orders/company` — both screens mount
   * this, and Carbon's `FilterableMultiSelect` requires a real, unique `id`. */
  idPrefix: string;
  options: OrderStateOption[];
  selected: OrderState[];
  onChange: (states: OrderState[]) => void;
}

/**
 * The one filter the pre-Carbon MRT table actually drove: a multi-select on the `state` column
 * (`filterVariant: "multi-select"`). MRT's `orderType`/`currency` `columnFilters` branches in the
 * old `apiParams` builder were dead code — neither file ever defined a column with those
 * `accessorKey`s, so nothing in the UI could ever populate them. Only `state` is rebuilt here,
 * per `MaterialListFilters.tsx`'s "a filter bar above `DataTable`" pattern (Task 3's own
 * composition guidance — `DataTable` itself has no filter slot).
 */
const OrderStateFilter = ({
  idPrefix,
  options,
  selected,
  onChange,
}: OrderStateFilterProps) => {
  const { t } = useTranslation();
  const selectedItems = options.filter((option) =>
    selected.includes(option.value)
  );

  // A bare field: each caller owns the layout row (`.orders__filters`) so this can sit
  // beside other filters without a nested flex container skewing the alignment.
  return (
    <FilterableMultiSelect
      id={`${idPrefix}-state`}
      className="orders__state-select"
      titleText={t("tenders.form.state")}
      placeholder={t("tenders.form.state")}
      items={options}
      itemToString={(option) => option?.label ?? ""}
      selectedItems={selectedItems}
      onChange={({ selectedItems: next }) =>
        onChange((next ?? []).map((option) => option.value))
      }
    />
  );
};

export default OrderStateFilter;
